import React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { SUCCESS_GREEN } from './qcTheme';

const Body = styled('div')({ padding: '28px 32px 24px', maxWidth: '540px' });
const TitleRow = styled('div')({ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' });
const Title = styled('h2')({ margin: 0, fontSize: '1.25rem', fontWeight: 600, color: '#1c2a42' });
const Blurb = styled('p')({ margin: '0 0 16px', fontSize: '0.9rem', color: 'rgba(0,0,0,0.65)', lineHeight: 1.5 });
const Steps = styled('ol')({ margin: '0 0 20px', paddingLeft: '20px', fontSize: '0.875rem', color: 'rgba(0,0,0,0.75)', lineHeight: 1.7 });
const Actions = styled('div')({ display: 'flex', justifyContent: 'flex-end', gap: '12px' });

// Celebration + pointer only — finalization happens exclusively via Admin -> Assessments -> Actions -> Finalize Assessment.
export default function QcApprovedNextStepsModal(props: {
  open: boolean;
  approvedCount: number;
  unitLabel?: string;
  onGoToAssessments?: () => void;
  onClose: () => void;
}): JSX.Element {
  const { open, approvedCount, unitLabel, onGoToAssessments, onClose } = props;
  return (
    <Dialog open={open} onClose={onClose}>
      <Body>
        <TitleRow>
          <TaskAltIcon sx={{ color: SUCCESS_GREEN, fontSize: 26 }} />
          <Title>All QC Issues Approved</Title>
        </TitleRow>
        <Blurb>
          {approvedCount} QC issue{approvedCount === 1 ? '' : 's'}{unitLabel ? ` on ${unitLabel}` : ''} have
          been approved. The QC review is ready to be finalized.
        </Blurb>
        <Steps>
          <li>Open Admin &rarr; Assessments.</li>
          <li>On this assessment&apos;s row, choose Actions &rarr; Finalize Assessment.</li>
          <li>
            Review the QC score and assessor email notes, then approve &mdash; finalizing records the
            score, emails the assessor, and moves the service provider into Remediation.
          </li>
        </Steps>
        <Actions>
          <Button onClick={onClose}>Close</Button>
          {onGoToAssessments && (
            <Button variant='contained' onClick={onGoToAssessments}>Go to Assessments</Button>
          )}
        </Actions>
      </Body>
    </Dialog>
  );
}
